import { NextPage } from 'next';
import { AppPrivacyPolicyContent } from '../containers/privacy';

const AppPrivacyPolicy: NextPage = () => {
  return <AppPrivacyPolicyContent />;
};

export default AppPrivacyPolicy;
